module.exports = __webpack_public_path__ + "static/media/healthLocker.1c9505fb.svg";